/**
 * Countries actions types
 */

export const COUNTRIES_REQUESTED = '[COUNTRIES] REQUESTED';
export const COUNTRIES_SUCCEEDED = '[COUNTRIES] SUCCEEDED';
export const COUNTRIES_FAILED = '[COUNTRIES] FAILED';
